import { Citation } from '@/models/Citations';
import { PaperCard } from '@/components/reader/components/PaperCard/PaperCard';

import { BoundingBox } from '@allenai/pdf-components';
import { Fragment, RefObject, useCallback, useState } from 'react';
import { Popover } from 'antd';
import classNames from 'classnames';

type Props = {
  citation: Citation;
  parentRef: RefObject<HTMLElement>;
};

export const CitationPopover: React.FunctionComponent<Props> = ({
  citation,
  parentRef,
}: Props) => {
  const [isPopoverVisible, setIsPopoverVisible] = useState(false);
  const paper = JSON.stringify(citation, null, 2);

  // Handler triggered when Ant Popover is shown or hidden
  const handleVisibleChange = useCallback(
    (isVisible: boolean) => {
      setIsPopoverVisible(isVisible);
    },
    [citation, paper],
  );

  const renderPopoverContent = useCallback(() => {
    return (
      <div className="reader__popover__citation">
        <PaperCard corpusId={citation.citedPaperId} />
      </div>
    );
  }, [paper]);

  return (
    <Fragment>
      {citation.boundingBoxes.map((box, idx) => (
        // Create a BoundingBox/Popover pair for each bounding box in the citation.
        // This accounts for citations that span multiple pages and avoids buggy popover placement
        // behavior that occurs when the inner BoundingBox is placed in a loop.
        <Popover
          key={idx}
          // Passing this ref mounts the popover "inside" the scrollable content area
          // instead of using the entire browser height.
          // @ts-ignore there's something wonky with the types here
          getPopupContainer={() => parentRef.current}
          content={renderPopoverContent}
          trigger="click"
          onVisibleChange={handleVisibleChange}
        >
          <BoundingBox
            className={classNames(
              'reader__popover__bbox',
              isPopoverVisible ? 'selected' : '',
            )}
            page={box.page}
            top={box.top}
            left={box.left}
            height={box.height}
            width={box.width}
            isHighlighted={true}
          />
        </Popover>
      ))}
    </Fragment>
  );
};
